import { toggleIdInMap } from '@store/debugger';

export const triggerIdInMap = () => {
    toggleIdInMap();
    window.location.reload();
};
